import { ACTION_NAMES, ACTION_TYPES } from "../../../constants/actionBar";
import {
  SFDonutLargeIcon,
  SFDownloadIcon,
  SFMoreVerticalIcon,
  SFSettingsIcon,
  SFHistoryIcon,
  SFStarBorderIcon,
  SFStarIcon,
  SFAddBoxIcon,
  SFEditIcon,
  SFUploadIcon,
  SFRefreshIcon,
  SFFilterIcon,
  SFRowGroupIcon,
  SFMarkReviewedIcon,
  SFManageTaxonomyIcon,
  SFBenchmarkIcon,
  SFArrowMergeIcon,
  SFCopyIcon,
  SFCheckCircleOutlineIcon,
  SFMarkInactiveIcon,
  SFRateReviewOutlinedIcon,
  SFVerifiedUserOutlinedIcon,
  SFSourceIcon,
  SFPlaylistIcon,
  SFDeleteSweepOutlinedIcon,
  SFPlaceHolder,
  SFInfoIcon,
  SFTasksInProgressIcon,
  SFCommentsIcon,
  SFScoreIcon,
} from "../../icons";

/**
 * Retrieves the array of icon action definition templates.
 * @param {Function} t The translation function from i18next.
 * @returns {Array} An array of icon action definition templates.
 */
export const getIconActionDefTemplates = (t) => {
  return [
    {
      name: ACTION_NAMES.SECTOR,
      type: ACTION_TYPES.ICON,
      iconProps: {
        icon: <SFDonutLargeIcon />,
        tooltip: t("components.actionBar.tooltips.sectors"),
        overflowLabel: t("components.actionBar.tooltips.sectors"),
      },
    },
    {
      name: ACTION_NAMES.DOWNLOAD,
      type: ACTION_TYPES.ICON,
      iconProps: {
        icon: <SFDownloadIcon />,
        tooltip: t("components.actionBar.tooltips.download"),
        overflowLabel: t("components.actionBar.tooltips.download"),
      },
    },
    {
      name: ACTION_NAMES.MORE,
      type: ACTION_TYPES.ICON,
      iconProps: {
        icon: <SFMoreVerticalIcon />,
        tooltip: t("components.actionBar.tooltips.more"),
        overflowLabel: t("components.actionBar.tooltips.more"),
      },
    },
    {
      name: ACTION_NAMES.SETTINGS,
      type: ACTION_TYPES.ICON,
      iconProps: {
        icon: <SFSettingsIcon />,
        tooltip: t("components.actionBar.tooltips.settings"),
        overflowLabel: t("components.actionBar.tooltips.settings"),
      },
    },
    {
      name: ACTION_NAMES.HISTORY,
      type: ACTION_TYPES.ICON,
      iconProps: {
        icon: <SFHistoryIcon />,
        tooltip: t("components.actionBar.tooltips.history"),
        overflowLabel: t("components.actionBar.tooltips.history"),
      },
    },
    {
      name: ACTION_NAMES.ADD_FAVORITE,
      type: ACTION_TYPES.ICON,
      iconProps: {
        icon: <SFStarBorderIcon />,
        tooltip: t("components.actionBar.tooltips.addFavorite"),
        overflowLabel: t("components.actionBar.tooltips.addFavorite"),
      },
    },
    {
      name: ACTION_NAMES.REMOVE_FAVORITE,
      type: ACTION_TYPES.ICON,
      iconProps: {
        icon: <SFStarIcon />,
        tooltip: t("components.actionBar.tooltips.removeFavorite"),
        overflowLabel: t("components.actionBar.tooltips.removeFavorite"),
      },
    },
    {
      name: ACTION_NAMES.ADD,
      type: ACTION_TYPES.ICON,
      iconProps: {
        icon: <SFAddBoxIcon />,
        tooltip: t("components.actionBar.tooltips.add"),
        overflowLabel: t("components.actionBar.tooltips.add"),
      },
    },
    {
      name: ACTION_NAMES.EDIT,
      type: ACTION_TYPES.ICON,
      iconProps: {
        icon: <SFEditIcon />,
        tooltip: t("components.actionBar.tooltips.edit"),
        overflowLabel: t("components.actionBar.tooltips.edit"),
      },
    },
    {
      name: ACTION_NAMES.IMPORT,
      type: ACTION_TYPES.ICON,
      iconProps: {
        icon: <SFUploadIcon />,
        tooltip: t("components.actionBar.tooltips.import"),
        overflowLabel: t("components.actionBar.tooltips.import"),
      },
    },
    {
      name: ACTION_NAMES.REFRESH,
      type: ACTION_TYPES.ICON,
      iconProps: {
        icon: <SFRefreshIcon />,
        tooltip: t("components.actionBar.tooltips.refresh"),
        overflowLabel: t("components.actionBar.tooltips.refresh"),
      },
    },
    {
      name: ACTION_NAMES.FILTER,
      type: ACTION_TYPES.ICON,
      iconProps: {
        icon: <SFFilterIcon />,
        tooltip: t("components.actionBar.tooltips.filter"),
        overflowLabel: t("components.actionBar.tooltips.filter"),
      },
      filterParams: {},
    },
    {
      name: ACTION_NAMES.GROUP_BY,
      type: ACTION_TYPES.ICON,
      iconProps: {
        icon: <SFRowGroupIcon />,
        tooltip: t("components.actionBar.tooltips.groupBy"),
        overflowLabel: t("components.actionBar.tooltips.groupBy"),
      },
      groupParams: {},
    },
    {
      name: ACTION_NAMES.MARK_REVIEWED,
      type: ACTION_TYPES.ICON,
      iconProps: {
        icon: <SFMarkReviewedIcon />,
        tooltip: t("components.actionBar.tooltips.markReviewed"),
        overflowLabel: t("components.actionBar.tooltips.markReviewed"),
      },
    },
    {
      name: ACTION_NAMES.MANAGE_TAXONOMY,
      type: ACTION_TYPES.ICON,
      iconProps: {
        icon: <SFManageTaxonomyIcon />,
        tooltip: t("components.actionBar.tooltips.manageTaxonomy"),
        overflowLabel: t("components.actionBar.tooltips.manageTaxonomy"),
      },
    },
    {
      name: ACTION_NAMES.BENCHMARK_MAPPING,
      type: ACTION_TYPES.ICON,
      iconProps: {
        icon: <SFBenchmarkIcon />,
        tooltip: t("components.actionBar.tooltips.benchmarkMapping"),
        overflowLabel: t("components.actionBar.tooltips.benchmarkMapping"),
      },
    },
    {
      name: ACTION_NAMES.MAPPED_ORG_JOBS,
      type: ACTION_TYPES.ICON,
      iconProps: {
        icon: <SFArrowMergeIcon />,
        tooltip: t("components.actionBar.tooltips.mappedOrgJobs"),
        overflowLabel: t("components.actionBar.tooltips.mappedOrgJobs"),
      },
    },
    {
      name: ACTION_NAMES.COPY,
      type: ACTION_TYPES.ICON,
      iconProps: {
        icon: <SFCopyIcon />,
        tooltip: t("components.actionBar.tooltips.copy"),
        overflowLabel: t("components.actionBar.tooltips.copy"),
      },
    },
    {
      name: ACTION_NAMES.MARK_ACTIVE,
      type: ACTION_TYPES.ICON,
      iconProps: {
        icon: <SFCheckCircleOutlineIcon />,
        tooltip: t("components.actionBar.tooltips.markActive"),
        overflowLabel: t("components.actionBar.tooltips.markActive"),
      },
      clearSelection: true,
    },
    {
      name: ACTION_NAMES.MARK_INACTIVE,
      type: ACTION_TYPES.ICON,
      iconProps: {
        icon: <SFMarkInactiveIcon />,
        tooltip: t("components.actionBar.tooltips.markInactive"),
        overflowLabel: t("components.actionBar.tooltips.markInactive"),
      },
      clearSelection: true,
    },
    {
      name: ACTION_NAMES.EDIT_RATING,
      type: ACTION_TYPES.ICON,
      iconProps: {
        icon: <SFRateReviewOutlinedIcon />,
        tooltip: t("components.actionBar.tooltips.editRating"),
        overflowLabel: t("components.actionBar.tooltips.editRating"),
      },
    },
    {
      name: ACTION_NAMES.TEST,
      type: ACTION_TYPES.ICON,
      iconProps: {
        icon: <SFVerifiedUserOutlinedIcon />,
        tooltip: t("components.actionBar.tooltips.test"),
        overflowLabel: t("components.actionBar.tooltips.test"),
      },
    },
    {
      name: ACTION_NAMES.SOURCE,
      type: ACTION_TYPES.ICON,
      iconProps: {
        icon: <SFSourceIcon />,
        tooltip: t("components.actionBar.tooltips.source"),
        overflowLabel: t("components.actionBar.tooltips.source"),
      },
    },
    {
      name: ACTION_NAMES.ADD_TO_PLAYLIST,
      type: ACTION_TYPES.ICON,
      iconProps: {
        icon: <SFPlaylistIcon />,
        tooltip: t("components.actionBar.tooltips.addToPlaylist"),
        overflowLabel: t("components.actionBar.tooltips.addToPlaylist"),
      },
    },
    {
      name: ACTION_NAMES.DELETE_PLAYLIST,
      type: ACTION_TYPES.ICON,
      iconProps: {
        icon: <SFDeleteSweepOutlinedIcon />,
        tooltip: t("components.actionBar.tooltips.deletePlaylist"),
        overflowLabel: t("components.actionBar.tooltips.deletePlaylist"),
      },
    },
    {
      name: ACTION_NAMES.HELP,
      type: ACTION_TYPES.ICON,
      iconProps: {
        icon: <SFPlaceHolder />,
        tooltip: t("components.actionBar.tooltips.help"),
        overflowLabel: t("components.actionBar.tooltips.help"),
      },
    },
    {
      name: ACTION_NAMES.INFO,
      type: ACTION_TYPES.ICON,
      iconProps: {
        icon: <SFInfoIcon />,
        tooltip: t("components.actionBar.tooltips.info"),
        overflowLabel: t("components.actionBar.tooltips.info"),
      },
    },
    {
      name: ACTION_NAMES.TASKS_IN_PROGRESS,
      type: ACTION_TYPES.ICON,
      iconProps: {
        icon: <SFTasksInProgressIcon />,
        tooltip: t("components.actionBar.tooltips.tasksInProgress"),
        overflowLabel: t("components.actionBar.tooltips.tasksInProgress"),
      },
    },
    {
      name: ACTION_NAMES.COMMENTS,
      type: ACTION_TYPES.ICON,
      iconProps: {
        icon: <SFCommentsIcon />,
        tooltip: t("components.actionBar.tooltips.comments"),
        overflowLabel: t("components.actionBar.tooltips.comments"),
      },
    },
    {
      name: ACTION_NAMES.CONFIDENCE_SCORE,
      type: ACTION_TYPES.ICON,
      iconProps: {
        icon: <SFScoreIcon />,
        tooltip: t("components.actionBar.tooltips.confidenceScore"),
        overflowLabel: t("components.actionBar.tooltips.confidenceScore"),
      },
    },
  ];
};
